import { ContentIcon } from "@dropbox/dash-component-library";
import { Chip } from "@dropbox/dig-components/chip";
import { UIIcon } from "@dropbox/dig-icons";
import { LinkLine, StacksLine } from "@dropbox/dig-icons/assets";
import { getTimeAgoStringFromTimestamp } from "@mirage/search/SearchResults/util/resultUtil";
import { useTheme } from "@mirage/service-settings/theming/useTheme";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import { UrlSrcIcon } from "@mirage/shared/icons";
import { DashTruncateWithTooltip } from "@mirage/shared/util/DashTruncateWithTooltip";
import { faviconSrcForSrcUrl } from "@mirage/shared/util/favicon";
import i18n from "@mirage/translations";
import { BaseResultRow } from "./BaseResultRow";
import styles from "./StackItemResultRow.module.css";

export const StackItemResultRow = (props: {
  scoredResult: typeahead.ScoredStackItem;
  isSelected: boolean;
}) => {
  const {
    scoredResult: { result },
  } = props;
  const isDarkMode = useTheme();
  const timeAgoString = result.lastModifiedTime
    ? getTimeAgoStringFromTimestamp(result.lastModifiedTime * 1000, true)
    : undefined;
  const chipContent =
    result.stackIds.length === 1 && result.stackIds[0].name
      ? result.stackIds[0].name
      : `${result.stackIds.length} ${i18n.t(
          "stack_item_typeahead_subtitle_badge",
        )}`;

  const icon = (
    <ContentIcon
      icon={
        result.url ? (
          <UrlSrcIcon
            name={i18n.t("icon_for_item")}
            size="100%"
            iconUrl={faviconSrcForSrcUrl(result.url, 32, isDarkMode)}
          />
        ) : (
          <UIIcon src={LinkLine} />
        )
      }
      hasBackground={false}
      size="medium"
    />
  );

  // eslint-disable-next-line no-constant-condition
  return (
    <BaseResultRow
      icon={icon}
      title={result.custom_name || result.name}
      subtitle={timeAgoString}
      additionalMetadata={[
        <Chip variant="standard" size="small" key={chipContent}>
          <Chip.IconAccessory>
            <UIIcon src={StacksLine} />
          </Chip.IconAccessory>
          <Chip.Content className={styles.chipContent}>
            <DashTruncateWithTooltip
              lines={1}
              tooltipProps={{ title: chipContent }}
            >
              {chipContent}
            </DashTruncateWithTooltip>
          </Chip.Content>
        </Chip>,
      ]}
    />
  );
};
